import enLocal from 'vant/lib/locale/lang/en-US'
import enJame from './languageJame/en'
import enGaea from './languageGaea/en'
import enAllen from './languageAllen/en'
const en = {
  300000: 'New Year Gifts',
  300001: '2022 New Year Gifts',
  300002: 'SuperEx will spend the New Year with you!',
  300003: 'Dear SuperEx users:<br>To celebrate the grand launch of SuperEx on the occasion of the New Year<br>we will randomly send out New Year gift packages worth 1,000,000 USDT by Airdrop.<br>Specific details of the activity are as follows:',
  300004: 'Time: <br>From 2022.01.01 00:00 ET To 2022.02.15 23:59 ET',
  300005: 'Activity 1: Share the activity poster and get Airdrop',
  300006: 'Share the event poster to Telegram cryptocurrency groups with no less than 1000 people, and add a note "Spend the New Year with SuperEx and start 2022 with a million dollar gift!" Or On your personal Twitter account, share the event poster with the words "Millions dollar gift is waiting for you. SuperEx will spend the New Year with you!" . Pin the tweet on your feed and upload a screenshot of the post to customer service and you will have a chance to get 5 ET (worth 5 USDT).',
  300007: 'Activity 2: Inviting new VIP members',
  300008: 'During the activity, the number of valid invitations is the number of users who have successfully registered from a friend\'s invitation and successfully deposited more than 100 USDT. Higher the number of successful invitations, higher the VIP level a user can obtain. The activity is valid for - 30 days. ',
  300009: 'Activity 3: New users can deposit and get ET rewards',
  300010: 'During the event, newly registered users will receive ET rewards when their net deposit amount reaches a certain range from the table below and completes a transaction.',
  300011: 'Precautions:',
  300012: '1.Each participating user can receive rewards only once.<br>2.All participating users abide by the SuperEx Terms of Service by default, and will immediately be unqualified from the even if any violations are found.<br>3.SuperEx reserves the right to modify terms of this event without notifying users in advance. <br>4.SuperEx will cancel the eligibility for non-compliant users to participate in the event and disable the use of related SuperEx accounts. <br>5.SuperEx reserves the right of final interpretation of this event.',
  300013: 'Get it now',
  300014: 'SuperEx Team',
  300015: '2022.01.01',
  300016: 'Follow SuperEx official website: SuperEx.com to learn more',
  300017: 'Net Deposit（{coin}）',
  300018: 'Bonus（{coin}）',
  300019: 'For 180 days',
  300020: 'Net deposit = Total deposit amount-Total withdrawal amount',
  300021: 'ET holdings',
  300022: 'Maker/Taker',
  300023: 'Valid invitations',
  300024: 'Gift validity',
  300025: 'Activity  conditions',
  300026: 'Note: All complimentary VIP levels do not require ET holdings.',
  300027: 'Copy Successful',
  300028: 'Copy failed',

  300029: 'Download SuperEx APP',
  300030: 'Trade anytime, anywhere',
  300031: 'Create SuperEx Account',
  300032: '若您已有SuperEx账户，请先登录',
  300033: 'Email',
  300034: 'Mobile',
  300035: 'Mobile number',
  300036: 'Password',
  300037: 'Referral ID (Optional)',
  300038: 'I have read and agree to',
  300039: 'SuperEx\'s Terms of Service',
  300040: 'I am over 18 age, and I agree to SuperEx\'s Terms',
  300041: 'Register',
  300042: 'Security Verification',
  300043: 'Select area code',
  300044: 'Search',
  300045: 'Please enter your mobile number',
  300046: 'Please enter correct mobile number',
  300047: 'Please enter your email address',
  300048: 'Please enter a valid email address',
  300049: 'Please enter your password',
  300050: 'At least 8 characters, including uppercase letters and numbers',
  300051: 'Email verification code',
  300052: 'Phone verification code',
  300053: 'Google/Microsoft Auth',
  300054: 'Google/Microsoft Authenticator',
  300055: 'For your account security, please complete the following verification operations',
  300056: 'Submit',
  300057: '6-digit code will be sent to {phone}',
  300058: 'Code will be sent to {email}',
  300059: 'Please enter the 6-digit SuperEx/Google/Microsoft verification code',
  300060: 'Enter 6-digit verification code',
  300061: 'Send Code',
  300062: 'Resend in {timeout}s',
  300063: 'Language',
  300064: 'Reviewing',
  300065: 'Enter English letters or common punctuation marks',

  300066: 'Task Center',
  300067: 'Rebate ranking battle.',
  300068: 'Up to <em class="bold normal" style="font-size: 1.2rem;color: #FFC72B;">1BTC</em> waiting for you!',
  300069: 'Invite',
  300070: 'Leaderboard',
  300071: 'Unlocking Rules',
  300072: 'Complete task to win rewards',
  300073: 'Rebate ranking battle. Up to 1 BTC waiting for you!',
  300074: 'Complete a transaction to unlock ET',
  300075: 'Complete all the above tasks to get whitelisted and SuperEx will randomly airdrop a large amount of ET tokens to whitelisted users from time to time.',
  300076: 'Daily Ranking',
  300077: 'Total Ranking',
  300078: 'Terms of Service',
  300079: 'My rewards',

  300080: 'Locked amount',
  300081: 'Unlock amount',
  300082: 'Unlock amount = trading fee * unlock difficulty / ET price',
  300083: 'Go to trade',
  300084: 'Ranking',
  300085: 'Account',
  300086: 'Commission',
  300087: 'Note: Daily ranking is calculated until 0:00 of the day (UTC-4), and the rewards will be issued the next day. There may be errors in the data for reference only.',
  300088: 'Note: Rewards will be issued within 3 working days after the event ends, and the data may have errors for reference only.',
  300089: 'View More',

  300090: 'Collapse',
  300091: 'You are already a whitelisted user!',
  300092: 'Enter your {type} account',
  300093: 'Final Step',
  300094: 'Follow us on Twitter',
  300095: 'Join our Official Telegram Group',
  300096: 'Deposit crypto',
  300097: 'Trade Spot',
  300098: 'Trade Futures',
  300099: 'Refer a friend',

  300100: 'Invite a friend to trade',
  300101: 'Recommend a friend to trade more',
  300102: 'Deposit',
  300103: 'Follow',
  300104: 'Congrats',
  300105: 'Collected (times)',
  300106: 'Not yet open',
  300107: 'Join',
  300108: 'No records found',
  300109: 'Completed',
  300110: 'Great news! Let\'s win some free rewards and refer friends to enjoy more benefits',
  300111: 'Cancel',
  300112: 'Submit',
  300113: 'Do not resubmit',
  300114: 'There are currently no tasks',
  300115: 'Stay tuned for more tasks',
  300116: 'Stay tuned for more events',
  300117: 'Please enter your account',
  300118: 'Please enter your account',
  300119: 'Denied',
  300120: 'Instant Sign Up for SuperEx',
  300121: 'Sign Up',
  300122: 'Expired',
  300123: 'White Paper',

  300124: 'Mystery Box',
  300125: 'Receive 1,000 USDT Reward in Crypto Mystery Box with <em class="normal bold" style="color: #FFC72B">100%</em> Winning Rate',
  300126: 'Rules',

  300127: 'Open Mystery Box',
  300128: 'Number of draws',
  300129: 'Remaining (mine)',
  300130: 'Opened (Total USDT)',
  300131: 'Rewards',
  300132: 'How to participate',
  300133: 'Share your invitation link',
  300134: 'Complete tasks',
  300135: 'Invite your friends to register and complete trading tasks',
  300136: 'Receive Mystery Box',

  300137: 'Complete tasks and get the Mystery Box',
  300138: 'This event has ended, please look forward to the next event!',
  300139: 'This event has not yet started, so stay tuned!',
  300140: 'Event Rules',
  300141: 'OK',
  300142: 'Time',
  300143: 'Inquire',
  300144: 'Email Authentication ',
  300145: 'Invite',
  300146: 'Light up the jack-o-lanterns and have fun with <em class="normal" style="color: #FFC72B">Halloween</em>',
  300147: 'Sign in for <em class="normal" style="color: #FFC72B">{num}</em> consecutive days and have a chance to win the <em class="normal" style="color: #FFC72B">{amount} ET</em> prize',
  300148: 'List of winners',
  300149: 'Daily sign-in',

  300150: 'You have logged in {num} days',
  300151: 'Prize Draw',
  300152: 'Signed in',
  300153: 'Sign in',
  300154: '',
  300155: '',
  300156: 'Sign in',
  300157: 'Received a contract fee discount coupon!',
  300158: 'VIP upgrade successfully!',
  300159: 'Get a chance to win the lottery!',

  300160: 'Contract Fee Coupon',
  300161: 'VIP Upgrade',
  300162: '',
  300163: 'You have <em class="normal" style="color: #FFC72B">{num}</em> times of re-signing opportunities',
  300164: 'Get a chance to sign in',
  300165: 'Can re-sign in',
  300166: 'Tips',
  300167: 'Re-signed successfully',
  300168: 'You don\'t have the number of sign-ins yet, you can get one re-sign in for a net deposit of ≥{num} {symbol} on the same day.',
  300169: 'Log In',

  300170: 'You reached the re-sign in limit',
  300171: 'Winner list of users who have signed in for 7 consecutive days',
  300172: 'Sign in continuously to get the following rewards',
  300173: 'Claimed',
  300174: '{num} Days',
  300175: 'Coupon',
  300176: 'My VIP Level',
  300177: 'Participate in the lottery',
  300178: 'Congratulations!',
  300179: 'Sign in successful',
  300180: '',
  300181: 'Academy',
  300182: 'News',
  300183: 'Data',
  300184: 'Learn',
  300185: 'Get an in-depth look at the major events in the global crypto industry',
  300186: 'Get a quick overview of the latest events in the crypto industry around the world',
  300187: 'Learn everything about blockchain, Web3 and cryptocurrency',
  300188: 'Read more',
  300189: 'Videos',
  300190: 'Loading',
  300191: 'All loaded',
  300192: 'All',
  300193: 'Tournament Not Started',
  300194: 'Pick the winner of the world cup matches and win <em class="normal" style="color:#DBFF00">rewards</em>',
  300195: 'Event Time',
  300196: 'Voting Record',
  300197: 'Group Stage',
  300198: '{num} Group',
  300199: 'Prize pool: {num}',
  300200: 'Support',
  300201: 'Knockout Stage',
  300202: 'Competition',
  300203: 'Deadline to vote',
  300204: 'Vote',
  300205: 'Please enter the number of votes',
  300206: 'Minimum number of bets: {num}ET',
  300207: 'Prediction Time',
  300208: 'Betting on teams',
  300209: 'Votes',
  300210: 'Prize Amount',
  300211: 'Qualified Teams',
  300212: 'D',
  300213: 'H',
  300214: 'M',
  300215: 'S',
  300216: 'Matches',
  300217: 'Event has not started yet',
  300218: '1/4 Final',
  300219: 'Confirm',
  300220: 'Number of votes',
  300221: 'Insufficient Balance',
  300222: 'Deposit',
  300223: 'Prediction Successful',
  300224: '1/8 Final',
  300225: 'Semi-final',
  300226: 'Third and fourth place finalists',
  300227: 'Final',
  300228: 'Win',
  300229: 'Loss',
  300230: 'Total Prize Pool:{num} ET',
  300231: 'View More Matches',
  300232: 'Other Competitions',
  300233: 'Currency',
  300234: 'Market Price',
  300235: '24h chg%',
  300236: 'New User Guide',
  300237: 'Start learning digital currency trading now',
  300238: 'Global Presence',
  300239: 'Borderless, community decentralization and autonomy, team decentralization is the ultimate form of SuperEx development',

  300240: 'Zero security risk',
  300241: 'Decentralized SuperWallet is integrated, and the private key is encrypted and stored on the user device. Not affected by code security, politics and other factors',
  300242: 'No registration & KYC ',
  300243: 'Wallet authorized transactions, no registration, no KYC, transaction settlements are completed on the chain, can not be tampered with, safe and transparent',
  300244: 'Open system ',
  300245: 'Allow users to interact with Dapp or smart contracts, by opening SuperWallet, users can be authorized to participate in Meta, DeFi and NFTs  ',
  300246: 'Space Fund',
  300247: 'Space Fund is used for human exploration of space or to fund institutions or individuals that have made significant contributions to human exploration of space',
  300248: 'A Secure and easy-to-use Exchange',
  300249: 'Download the SuperEX mobile app to keep an eye on the markets and make trades at the perfect moment, wherever you are.',

  300250: 'More Download Options',
  300251: 'Every trade you make is fuel for humans to fly into space',
  300252: 'Register now',
  300253: 'iOS & Android<br>Scan to Download',
  300254: 'Authenticator',
  300255: 'The authenticator will generate a 2-step verification code for you. Keep your SuperEx account even more secure with 2-step verification.',
  300256: 'SuperEx Authenticator',
  300257: 'Google Auth',
  300258: 'Microsoft Auth',
  300259: 'Download client (iPhone)',

  300260: 'Download client (Android)',
  300261: 'The most secure digital asset trading platform of the world！',
  300262: 'About Us',
  300263: 'Terms',
  300264: 'Privacy',
  300265: 'Announcements',
  300266: 'Academy',
  300267: 'Beginners Center',
  300268: 'Spot Trading',
  300269: 'Futures',

  300270: 'FAQ',
  300271: 'Service',
  300272: 'Fees',
  300273: 'Rules',
  300274: 'Listing Application',
  300275: 'Referral',
  300276: 'Contact us',
  300277: 'Help Center',
  300278: 'Submit a Request',
  300279: 'Business Contacts',

  300280: 'Institutional Cooperation',
  300281: 'More',
  300282: 'Welcome back!',
  300283: 'Forgot password?',
  300284: "Don't have an account yet?",
  300285: 'Go to the APP or computer to recover the password',
  300286: 'OK',

  300287: 'Confirm',
  300288: 'To be announced',
  300289: 'To be claimed',

  300290: 'Already Joined',
  300291: 'Already Refunded',
  300292: 'Buying Rules',
  300293: "Buy <span style='color: #ffc72b;'>Goods</span>",
  300294: 'Choose and Purchase',
  300295: 'Awaiting Results',
  300296: 'Claim the item',
  300297: 'Deposit',
  300298: 'Buy Record',
  300299: 'Item List',
  300300: 'One-time participation fee',
  300301:'{num} copies have been sold. The item will be sold after reaching {price} {currency}.',
  300302: 'Join Now',
  300303: 'Join Again',
  300304: 'Select number of copies to purchase',
  300305: "1 copy requires <span style='color: #fa4d56;'>{minPrice} {currency}</span>, and a single item can be purchased at most",
  300306: 'copies',
  300307: 'You have {num} {currency}, the more copies you buy the higher the chance of acquiring!',
  300308: 'Buy',
  300309: 'Next Time',
  // 300309: '余额充值',
  300310: 'Congratulations!',
  300311: 'Claim',
  300312: 'Try again!',
  300313: 'Complete the crypto or P2P deposit on the APP.',
  // 300314: '我知道了',
  300315: 'Contact customer service on the app to claim the item.',
  // 300316: '我知道了',
  300317: 'Login / Register',
  300318: 'Cost {num} {currency}',
  300319: 'Item Description',
  300320: 'My participation',
  300321: 'Time',
  300322: 'Participating Items',
  300323: 'Number of copies purchased',
  300324: 'Refund amount',
  300325: 'Operation',
  300326: 'Claim',
  300327: 'Already have an account?',
  300328: 'Log in',
  300329: 'Authentication code',
  300330: 'Only show records from the last seven days',
  300331:'Authenticator',
  300332:'Download',
  300333:'1 USDT for 1 Bitcoin！',
  300334:"Buying price",
  300335:"Previous Results",
  300336:"期次",
  300337:"View Rules",
  300338:"Issue: [Phase {num}]",
  300339:"Purchase process",
  300340:"Successfully Purchased Users",
  300341:"Announcement Time",
  300342:"Share",
  300343:"Issue [{num}]",
  300345:"Download",
  300346:"Share your joy",
  300347:"Scan Code To Join",
  300348:"Claim the item",
  300349:"Note: Digital currency items will be sent to your account within 48 hours.",
  300350:"Contact customer service to claim other items",
  300351:"Go to view",
  300352:"Register Now",
  300353:"Registered",
  300354:'Registration is closed',
  300355:'Registration Successful',
  300356:'Open The App',
  300357:'Congratulations to {user} for acquiring {shop}!',
  300358:'Events Center',
  300359:'In Progress',
  300360:'Starting Soon',
  300361:'Ended',
  300362:'Join now',
  300363: 'Ended',
  300364: 'Winners',
  300365: 'Winners will be announced soon',


  310000:'Reward Overview',
  310001:'SCS Airdrop',
  300366: 'Currency',
  300367: 'Sell',
  200368: 'Pay',
  300369: 'Receive',
  300370: 'Get',
  300371: 'Single transaction limit:',
  300372: 'Payment Method',
  300373: 'Payment Method',
  300374: 'Payment provider',
  300375: 'Order details',
  300376: 'Amount (including transaction fees)',
  300377: 'Arrival time',
  300378: 'Disclaimer',
  300379: 'I have read and agree to the disclaimer',
  300380: "You will leave SuperEx and jump to <span>{name}</span>, a licensed financial institution that provides card payment processing capabilities as a third party. Any risk events that occur during use will be borne by <span>{name}</span>. Please read and agree to <a class= 'pointer' href={server}>Service Agreement</a> before using its services.If you have any questions about credit card deposits, please contact <a class='pointer' href={Customer}>{name} Customer Service</a> for more details.",
  300381: 'How to buy crypto on SuperEx ?',
  300382: 'How to Sell Cryptocurrency on SuperEx?',
  300383: 'Place your crypto order',
  300384: 'Choose the fiat currency you want to pay with and the crypto you want to buy. Enter the amount you want to spend.',
  300385: 'Verify your identity',
  300386: 'Complete KYC verification on SuperEx and the payment provider to complete the payment.',
  300387: 'Check your order details',
  300388: 'Check your deposit history to view the status of your order.',
  300389: 'FAQ',
  300390: '1. What payment methods can I use to buy cryptocurrency?',
  300391: 'SuperEx currently supports VISA, Mastercard, Apple Pay, Google Pay, and other payment methods. The supported third-party service providers include Mercuryo and alchemypay.',
  300392: '2. What cryptocurrencies can I purchase?',
  300393: 'SuperEx supports mainstream cryptocurrencies such as BTC, ETH, USDT, LTC, USDC, XRP, BCH, CRV, and TRX.',
  300394: '3. Does SuperEx monitor the quality and prices of the supported third-party service providers?',
  300395: 'SuperEx has carefully selected a number of service providers with trusted industry reputation, popularity, and security to provide users with streamlined services.',
  300396: '4. What fees do I have to pay to buy cryptocurrency?',
  300397: 'You pay a fee to the third-party service provider and an on-chain transfer fee. SuperEx does not charge any fees.',
  300398: '5. How long does it take to receive the cryptocurrency after payment?',
  300399: 'After your payment is completed on the third-party service provider platform, your cryptocurrency will be deposited into your spot account on SuperEx in around 2–10 minutes.',
  300400: '6. What if I encounter problems during the purchase process?',
  300401: 'Contact customer support if you encounter any problems during the transaction process. If you have not received the cryptocurrency after payment is completed, contact the third-party service provider to check the order details (this is usually the most efficient method). Due to the IP of your current region or certain policy reasons, you will have to select human verification.',
  300402: "Available",
  300403: 'Insufficient balance',
  300404: 'Please enter currency',
  300405: 'Enter fiat currency',
  300406: 'You have not completed identity verification',
  300407: "For the security of your account with other trading users, please complete identity verification first",
  300408: 'Get Verified',
  300409: 'Unverified',
  300410: 'Choose Currency',
  300411: 'Choose fiat currency',
  300412: 'All currencies',
  300413: 'All fiat currencies',
  300414: '≈{time} minutes',
  300415: 'P2P trading is not open to authorized wallet users at this time, please use your SuperEx account to log in and trade P2P',
  300416: 'https://support.superex.com/hc/en-001/articles/23084120565017',
  300417:'Buy',
  300418: 'Serial Number',
  300419: 'SuperEx Halloween Carnival',
  300420: 'Sign in to enjoy gifts and trade to win bonuses!',
  300421:'Type',
  300422:'Cryptocurrency Rewards',
  300423:'',
  300424:'',

  400000:'First Web3 Crypto Exchange',
  400001:'Join us to create a financial world',
  400002:'Every trade you make will help us advance human exploration of Mars and Space！',
  400003:'SuperEX Exciting Recap',
  400004:'Active Engagement and Shared Smiles: The Story of Our Activity Wall',
  400005:'Select language and region',
  400006:'0 RISK',
  400007:'NO KYC',
  400008:'OPEN',
  400009:'FUND',
  400010:'Mainnet Explorer',
  400011:'Testnet Explorer',
  400012:'Developer Docs',
  400013:'Other',
  400014:'ET Zone',
  400015:'Sell Channel',

  400017: 'Input 11-digit mobile number',

  ...enLocal,
  ...enJame,
  ...enGaea,
  ...enAllen
}
export default en;



// WEBPACK FOOTER //
// ./src/i18n/langs/en.js